module.exports = __webpack_public_path__ + "img/home-6.91854518.png";